import { createSlice } from "@reduxjs/toolkit";

const Slice = createSlice({
  name: "editor",
  initialState: {
    content: "",
    RemoveDuplicate: {
      show: false,
      id: null,
    },
    queryLength: 0,
    referenceLength: 0,
    metaValue:null
  },
  reducers: {
    editorContent: (state, action) => {
      state.content = action.payload;
    },
    treeStructure: (state, action) => {
      state.treecontent = action.payload;
    },
    expandedTree: (state, action) => {
      state.expandedtree = action.payload;
    },
    selectedStructure: (state, action) => {
      state.selectedStructure = action.payload;
    },
    setRemoveDuplicate: (state, action) => {
      state.RemoveDuplicate.show = action.payload.show;
      state.RemoveDuplicate.id = action.payload.id;
    },
    setQueryLength: (state, action) => {
      state.queryLength = action.payload;
    },
    setRefLength: (state, action) => {
      state.referenceLength = action.payload;
    },
    
  },
});

export const {
  editorContent,
  treeStructure,
  setRemoveDuplicate,
  setQueryLength,
  expandedTree,
  selectedStructure,
  setRefLength,
} = Slice.actions;

export default Slice.reducer;
